import { Injectable } from '@angular/core';
import * as _ from 'underscore';
import { IObject } from '../../../type_definitions/datatypes';

@Injectable()
export class HttpEtagService {
  private eTagRegistry:IObject = {};
  private urlPatterns:RegExp[] = [];

  public get allowedMethods():string[] {
    return ['POST', 'PUT', 'DELETE', 'PATCH'];
  }

  public getETag(url:string):string {
    const strippedUrl:string = this.findMatchAndStrip(url);
    if (strippedUrl !== null) {
      return this.eTagRegistry[ strippedUrl ];
    }
    return undefined;
  }

  public addETag(url:string, etag:string):void {
    const strippedUrl:string = this.findMatchAndStrip(url);
    if (strippedUrl !== null) {
      this.eTagRegistry[ strippedUrl ] = etag;
    }
  }

  public addUrlPattern(pattern:RegExp):void {
    this.urlPatterns.push(pattern);
  }

  public removeUrlPattern(pattern:RegExp):void {
    // eslint-disable-next-line no-var
    for (var i = 0; i < this.urlPatterns.length; i++) {
      if (pattern.toString() === this.urlPatterns[ i ].toString()) {
        break;
      }
    }

    if (i >= 0) {
      //found the pattern, remove all the eTags
      _.forEach(this.eTagRegistry, (eTag:string, url:string) => {
        if (url.match(pattern)) {
          delete this.eTagRegistry[ url ];
        }
      });

      //remove the pattern
      this.urlPatterns.splice(i, 1);
    }
  }

  private findMatchAndStrip(url:string):string {
    for (let i = 0; i < this.urlPatterns.length; i++) {
      const urlPattern:RegExp = this.urlPatterns[ i ];
      const match:RegExpMatchArray = url.match(urlPattern);

      if (!match) {
        continue;
      }

      //first entry in the match array will be the matched part of the string
      return match[ 0 ];
    }
    return null;
  }
}